export default __webpack_public_path__ + "static/media/mv_1080.c3dff328.mp4";